/**
 * @generated SignedSource<<42642e530694a68c72482c9dff10dab0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetails_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsAbout_user" | "PdpRespSidebarDetailsCustomization_user">;
  readonly " $fragmentType": "PdpRespSidebarDetails_user";
};
export type PdpRespSidebarDetails_user$key = {
  readonly " $data"?: PdpRespSidebarDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetails_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsAbout_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsCustomization_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5613b03af8c2610d7ed4c56974488514";

export default node;
